import {memo, useMemo} from 'react'
import {format} from 'date-fns'
import {MessageBubble} from '../message-bubble/MessageBubble'
import {DateHeader} from '../date-header/DateHeader'
import {ConversationMessage} from '../../types'

interface MessageGroupProps {
    messages: ConversationMessage[]
}

const MessageGroupComponent = ({messages}: MessageGroupProps) => {
    const groupedMessages = useMemo(() => {
        if (!messages || messages.length === 0) return []

        const groups: Array<{
            date: string
            messages: ConversationMessage[]
            showDateHeader: boolean
        }> = []

        let previousDate: string | null = null

        messages.forEach(message => {
            const messageDate = new Date(message.createdAt)
            const dateString = format(messageDate, 'yyyy-MM-dd')

            // Check if this is a new date
            if (previousDate !== dateString) {
                groups.push({
                    date: message.createdAt,
                    messages: [message],
                    showDateHeader: true
                })
                previousDate = dateString
            } else {
                // Add to the last group
                const lastGroup = groups[groups.length - 1]
                if (lastGroup) {
                    lastGroup.messages.push(message)
                }
            }
        })

        return groups
    }, [messages])

    return (
        <>
            {groupedMessages.reverse().map(group => (
                <div key={group.date} style={{width: '100%'}}>
                    {group.showDateHeader && <DateHeader date={group.date} />}
                    {group.messages.reverse().map(message => (
                        <MessageBubble key={message.id} message={message} />
                    ))}
                </div>
            ))}
        </>
    )
}

export const MessageGroup = memo(MessageGroupComponent)
